import { FC, useState } from 'react';
import Header from '../../../common/Header/Header';
import UnsavedChangesModal from '../../../common/UnsavedChangesModal/UnsavedChangesModal';
import { useCopyOptionRecipes } from '../../../services/option/option.service';
import Confirmation from './Confirmation/Confirmation';
import { CopyOptionRecipeStep } from './CopyOptionRecipe.types';
import ReviewChanges from './ReviewChanges/ReviewChanges';
import SelectOptionRecipes from './SelectOptionRecipes/SelectOptionRecipes';

const CopyOptionRecipe: FC = () => {
  const [step, setStep] = useState<CopyOptionRecipeStep>(0);
  const [selectedOptionRecipes, setSelectedOptionRecipes] = useState<any[]>([]);

  const { mutate, data, isLoading } = useCopyOptionRecipes();

  const renderStep = () => {
    switch (step) {
      default:
        return (
          <SelectOptionRecipes
            selectedOptionRecipes={selectedOptionRecipes}
            setSelectedOptionRecipes={setSelectedOptionRecipes}
            setStep={setStep}
          />
        );
      case 1:
        return (
          <ReviewChanges
            selectedOptionRecipes={selectedOptionRecipes}
            setStep={setStep}
            mutate={mutate}
            isLoading={isLoading}
          />
        );
      case 2:
        return <Confirmation rowData={data?.data} />;
    }
  };

  return (
    <>
      <Header
        breadcrumb={{ label: 'Back to Option Recipes', to: '/optionrecipes' }}
        title='Copy Option Recipes'
        stepTracker={
          step !== 2
            ? {
                currentStep: step,
                steps: [{ label: 'Select Spec', onClick: () => setStep(0) }, { label: 'Review' }],
              }
            : undefined
        }
      />
      {renderStep()}
      <UnsavedChangesModal unsavedChangesExist={step === 1} />
    </>
  );
};

export default CopyOptionRecipe;
